import apis from "../../core/apis.js";
import { isUndefined, assign } from "lodash/fp";

class PackagesResource {
  constructor($resource, Upload) {
    "ngInject";

    this.$resource = $resource;
    this.Upload = Upload;
    this.Users = "users";
  }

  getAll(options) {
    return this.$resource(apis.packages).get(options);
  }

  get(id) {
    return this.$resource(apis.packages + id).get();
  }

  search(query = "", params) {
    return this.$resource(apis.packages + "autocomplete/").get(
      assign(params, { query })
    );
  }

  post(item) {
    return this.$resource(apis.packages).save(item);
  }

  update(id, item = {}) {
    return this.$resource(apis.packages + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  addOption(id, item = {}) {
    return this.$resource(apis.packages + id).save(item);
  }

  iconUpload(id, data) {
    const url = `${apis.packages}${id}`;
    const request = this.Upload.upload({ method: "PATCH", url, data });
    return { $promise: request };
  }

  // Users
  getUsers(a, b) {
    let id;
    let params;
    const args = [...arguments].filter((arg) => !isUndefined(arg));
    switch (args.length) {
      case 1:
        id = a.id;
        params = a;
        break;
      case 2:
        b.user_id = a;
        id = b.id;
        params = b;
        break;
      default:
        break;
    }
    return this.$resource(`${apis.packages}${id}/${this.Users}`).get(params);
  }

  usersUpload(id, data) {
    const url = `${apis.packages}${id}/${this.Users}`;
    const request = this.Upload.upload({ method: "POST", url, data });
    return { $promise: request };
  }

  removeUser(id, users) {
    return this.$resource(`${apis.packages}${id}/${this.Users}`, null, {
      delete: { method: "DELETE", data: { user_ids: users } },
    }).delete();
  }

  exportCSV(packageId, optionId = "") {
    return this.$resource(
      `${apis.packages}${packageId}/${optionId}${this.Users}/export/`,
      null,
      {
        get: {
          method: "GET",
          transformResponse: (data, _headersGetter, status) => {
            return { ...angular.fromJson(data), status };
          },
        },
      }
    ).get();
  }

  // End of Users
}

export default PackagesResource;



// WEBPACK FOOTER //
// ./src/resources/packages/packages.resource.js